import { render, staticRenderFns } from "./ModeStep.vue?vue&type=template&id=080f981a&"
import script from "./ModeStep.vue?vue&type=script&lang=ts&"
export * from "./ModeStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-cfm/mfe-cfm/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080f981a')) {
      api.createRecord('080f981a', component.options)
    } else {
      api.reload('080f981a', component.options)
    }
    module.hot.accept("./ModeStep.vue?vue&type=template&id=080f981a&", function () {
      api.rerender('080f981a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wizard/ModeStep.vue"
export default component.exports